var map = {
	"./de_CH.svg": "fe23",
	"./en.svg": "eff4",
	"./fr_CH.svg": "eaed",
	"./home.svg": "ac9d",
	"./it_CH.svg": "e6fc",
	"./main.svg": "7895",
	"./previous.svg": "01ed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";